import { __decorate } from "tslib";
import { Component, EventEmitter, HostListener, Input, Output, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
/**
 * Dropdown Component
 */
let ModernDropdownComponent = class ModernDropdownComponent {
    constructor(sanitizer, themeService) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.borderRadiusSmaller = '';
        this.showItem = false;
        this.inputBackColor = '';
        this.textColor = '';
        this.setItm = new EventEmitter();
        this.themeService.getTheme().subscribe((data) => {
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
        });
    }
    ngOnInit() {
    }
    clickItem() {
        this.showItem = !this.showItem;
    }
    onDocumentClick(event) {
        const targetElement = event.target;
        if (targetElement.className !== 'modernSelected' &&
            targetElement.className !== 'modernSelectOptions' &&
            targetElement.className !== 'modernSelect' &&
            targetElement.className !== 'modernSelect has-error') {
            this.closeItem();
        }
    }
    closeItem() {
        this.showItem = false;
    }
    setItem(id) {
        this.itemId = id;
        this.setItm.emit(id);
    }
};
ModernDropdownComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
__decorate([
    Input()
], ModernDropdownComponent.prototype, "errorText", void 0);
__decorate([
    Input()
], ModernDropdownComponent.prototype, "hasError", void 0);
__decorate([
    Input()
], ModernDropdownComponent.prototype, "label", void 0);
__decorate([
    Input()
], ModernDropdownComponent.prototype, "items", void 0);
__decorate([
    Input()
], ModernDropdownComponent.prototype, "itemId", void 0);
__decorate([
    Input()
], ModernDropdownComponent.prototype, "formDesign", void 0);
__decorate([
    Output("setItm")
], ModernDropdownComponent.prototype, "setItm", void 0);
__decorate([
    HostListener('document:click', ['$event'])
], ModernDropdownComponent.prototype, "onDocumentClick", null);
ModernDropdownComponent = __decorate([
    Component({
        selector: 'ecd-modern-dropdown',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./modern-dropdown.component.html")).default
    })
], ModernDropdownComponent);
export { ModernDropdownComponent };
